import { createContext, useContext, useState } from 'react';

interface ScannerConfigurationContextType {
  isFormDirty: boolean;
  setIsFormDirty: React.Dispatch<React.SetStateAction<boolean>>;
}

const ScannerConfigurationContext =
  createContext<ScannerConfigurationContextType | null>(null);

export const useScannerConfigurationContext =
  (): ScannerConfigurationContextType => {
    const ctx = useContext(ScannerConfigurationContext);
    if (ctx === null) {
      throw new Error(
        'useScannerConfigurationContext must be used within ScannerConfigurationProvider',
      );
    } else {
      return ctx;
    }
  };

export const ScannerConfigurationProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);
  return (
    <ScannerConfigurationContext.Provider
      value={{ isFormDirty, setIsFormDirty }}
    >
      {children}
    </ScannerConfigurationContext.Provider>
  );
};
